// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"f88f06f3","89":"2c2264dc","90":"d6f3fc67","158":"c0d3eec8","210":"9aa5ec07","467":"2a26e550","758":"d476f9ed","873":"a24123f6","894":"e85f65a4"}[chunkId] + ".chunk.css";
};